import React from 'react'
import { CircularProgress, Tooltip } from '@material-ui/core'
import ErrorDisplaySimplified from 'Components/ErrorDisplay/ErrorDisplaySimplified'
import { Label, Typography } from 'procyon-ui'

const stringSorter = (key) => (v1, v2) => (v1[key] || '').localeCompare(v2[key] || '')

// Common Actions Renderer
const renderActions = (_, row) => {
  return (
    <div className='flex items-center gap-2'>
      {/* FIXED: mapped to row.credentials.onClick */}
      <Tooltip title='View Credentials'>
        <div onClick={row.credentials?.onClick} className='cursor-pointer'>
          <Label text='Credentials' variant='grayBlue' />
        </div>
      </Tooltip>

      <Tooltip title='Delete'>
        <div onClick={row.delete?.onClick} className='cursor-pointer'>
          <Label text='Delete' variant='danger' />
        </div>
      </Tooltip>
    </div>
  )
}

export const awsColumns = () => [
  {
    dataIndex: 'UserName',
    title: 'User Name',
    fixed: 'left',
    width: 180,
    sorter: stringSorter('UserName'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'Account',
    title: 'Account',
    width: 130,
    sorter: stringSorter('Account'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'Arn',
    title: 'ARN',
    width: 250,
    sorter: stringSorter('Arn'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'error',
    title: 'Status',
    width: 100,
    render: (value) => {
      if (value?.loading) {
        return <CircularProgress style={{ marginLeft: '10px' }} size={20} color='primary' />
      }
      return <ErrorDisplaySimplified error={value?.error} hasError={value?.hasError} />
    }
  },
  {
    dataIndex: 'actions',
    title: 'Actions',
    width: 180, // Increased width to fit both buttons
    fixed: 'right',
    render: renderActions
  }
]

export const gcpColumns = () => [
  {
    dataIndex: 'Name',
    title: 'Name',
    fixed: 'left',
    width: 200,
    sorter: stringSorter('Name'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'Project',
    title: 'Project',
    width: 200,
    sorter: stringSorter('Project'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'Email',
    title: 'Email',
    width: 250,
    sorter: stringSorter('Email'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'error',
    title: 'Status',
    width: 100,
    render: (value) => {
      if (value?.loading) {
        return <CircularProgress style={{ marginLeft: '10px' }} size={20} color='primary' />
      }
      return <ErrorDisplaySimplified error={value?.error} hasError={value?.hasError} />
    }
  },
  {
    dataIndex: 'actions',
    title: 'Actions',
    width: 180,
    fixed: 'right',
    render: renderActions
  }
]

export const azureColumns = () => [
  {
    dataIndex: 'DisplayName',
    title: 'DisplayName',
    fixed: 'left',
    width: 200,
    sorter: stringSorter('DisplayName'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'Account',
    title: 'Account',
    width: 150,
    sorter: stringSorter('Account'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'ServicePrincipalId',
    title: 'Service Principal Id',
    width: 200,
    sorter: stringSorter('ServicePrincipalId'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'AppId',
    title: 'AppId',
    width: 200,
    sorter: stringSorter('AppId'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'AppObjectId',
    title: 'App ObjectId',
    width: 200,
    sorter: stringSorter('AppObjectId'),
    render: (value) => <Typography variant='body-regular'>{value}</Typography>
  },
  {
    dataIndex: 'error',
    title: 'Status',
    width: 100,
    render: (value) => {
      if (value?.loading) {
        return <CircularProgress style={{ marginLeft: '10px' }} size={20} color='primary' />
      }
      return <ErrorDisplaySimplified error={value?.error} hasError={value?.hasError} />
    }
  },
  {
    dataIndex: 'actions',
    title: 'Actions',
    width: 180,
    fixed: 'right',
    render: renderActions
  }
]
